import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'notifications',
        title: 'Notifications',
        translate: '',
        type: 'item',
        icon: 'notifications',
        url: '/notifications',
        badge: null
    },
    {
        id: 'faq',
        title: 'Faq',
        translate: '',
        type: 'item',
        icon: 'help',
        url: '/faq',
        badge: null
    },
    {
        id: 'ads',
        title: 'Ads',
        translate: '',
        type: 'item',
        icon: 'business_center',
        url: '/ads'
    },
    {
        id: 'calendar',
        title: 'Calendar',
        translate: '',
        type: 'item',
        icon: 'today',
        url: '/calendar',
        badge: null
    },
    {
        id: 'request',
        title: 'Requests',
        translate: '',
        type: 'item',
        icon: 'description',
        url: '/request',
        badge: null
    },
    {
        id: 'data',
        title: 'Documents',
        translate: '',
        icon: 'work',
        type: 'collapsable',
        children: [
            {
                id: 'download-management',
                title: 'All Documents',
                translate: '',
                type: 'item',
                icon: 'work',
                url: '/download',
                hidden: false
            }
        ]
    },
    {
        id: 'recommender',
        title: 'Recommendations',
        translate: '',
        type: 'item',
        icon: 'people',
        url: '/recommender',
        badge: null
    },
    {
        id: 'complaint',
        title: 'Complaints',
        translate: '',
        type: 'item',
        icon: 'sentiment_very_dissatisfied',
        url: '/complaint',
        badge: null
    },
    
];
